import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    CreateTimesheetSetup,
    EnterUserHoursInput,
    GenerateTimesheetSubmit,
    IApproverResponse,
    IPrograms,
    IReviewer,
    ISingleTimesheet,
    ITimeSheet,
    ITimesheetUsers,
    UpdateUserHoursInput
} from './timesheet.interface';

const API_URI = `${environment.apiBaseUrl}/timesheet`;
const API = `${environment.apiBaseUrl}/request-form`;

@Injectable({
    providedIn: 'root'
})
export class TimesheetService {
    http: HttpClient = inject(HttpClient);

    createTimesheetSetup(payload: CreateTimesheetSetup) {
        return this.http.post(`${API_URI}`, payload);
    }
    getProgramId(program: string) {
        return this.http.get<IPrograms[]>(`${API_URI}/${program}`);
    }
    getUserByProgramId(input: { id: string; query: string }) {
        return this.http.get<{ data: ITimesheetUsers[] }>(
            `${API_URI}/users/${input.query}/${input.id}`
        );
    }
    getWwuUsersByProgramId(programId: string) {
        return this.http.get(`${API_URI}/www/users/${programId}`);
    }
    updateUsersHours(payload: UpdateUserHoursInput) {
        return this.http.patch(`${API_URI}/user/update-hours`, payload);
    }

    enterUsersHours(payload: EnterUserHoursInput) {
        return this.http.post<EnterUserHoursInput>(`${API_URI}/user/enter-hours`, payload);
    }
    getSingleTimesheet(input: { id: string; query: string }) {
        return this.http.get<ISingleTimesheet>(
            `${API}/single/${input.id}?reviewerId=${input.query}`
        );
    }

    submitTimesheet(payload: GenerateTimesheetSubmit) {
        return this.http.post(`${API}/generated-timesheet/submit`, payload);
    }
    getTimesheetByReviewer(input: { id: string; query: string }) {
        return this.http.get<IReviewer[]>(`${API}/reviews/${input.id}?formTitle=${input.query}`);
    }

    getTimesheetsByApprovers(input: { id: string; query: string }) {
        return this.http.get<IApproverResponse[]>(
            `${API}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }
    getTimesheetBysUser(input: { id: string; query: string }) {
        return this.http.get<ITimeSheet[]>(`${API}/user/${input.id}?formTitle=${input.query}`);
    }
}
